import { TransactionDiscountAmount } from './TransactionDiscountAmount';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from '@heroui/react';
import { Icon } from '@iconify/react';
import type { SalesTransaction } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import { isDiscountedTransaction } from './transactionsMeta';

type TransactionDetailSellerProps = { transaction: SalesTransaction };
export const TransactionDetailSeller = ({
    transaction,
}: TransactionDetailSellerProps) => {
    const { t } = useTranslation('pages');
    return (
        <Card
            variant="secondary"
            className="mb-4 flex-row items-center gap-3 p-3"
            {...getNodeTestIdProp('transaction-detail-seller-card')}
        >
            <Icon
                aria-hidden="true"
                className="size-5 shrink-0 text-accent"
                icon="solar:user-bold-duotone"
            />
            <div className="min-w-0 flex-1">
                <Typography type="body-xs" color="muted">
                    {t('sales.widgets.transactions.modal.seller')}
                </Typography>
                <Typography
                    type="body-sm"
                    weight="semibold"
                    truncate
                    {...getNodeTestIdProp('transaction-detail-seller')}
                >
                    {transaction.seller.name}
                </Typography>
            </div>
            {isDiscountedTransaction(transaction) && (
                <div
                    className="flex shrink-0 flex-col items-end"
                    {...getNodeTestIdProp('transaction-detail-discount-stack')}
                >
                    <Typography
                        type="body-xs"
                        color="muted"
                        {...getNodeTestIdProp(
                            'transaction-detail-discount-label',
                        )}
                    >
                        {t('sales.widgets.transactions.modal.discounts')}
                    </Typography>
                    <span {...getNodeTestIdProp('transaction-detail-discount')}>
                        <TransactionDiscountAmount
                            amountTetri={transaction.discountTotalTetri}
                        />
                    </span>
                </div>
            )}
        </Card>
    );
};
